import React from 'react';
import { motion } from 'framer-motion';
import { Zap, BookOpen, Microscope, Scale, ShieldAlert, BarChart3 } from 'lucide-react';

const Vision = () => {
    return (
        <section id="vision" className="py-24 bg-background relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 w-1/3 h-full bg-primary/5 -skew-x-12 blur-3xl pointer-events-none"></div>

            <div className="container mx-auto px-6 relative z-10">
                <div className="text-center mb-16">
                    <span className="text-primary font-mono text-sm tracking-widest uppercase mb-4 block">LA TESIS</span>
                    <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">El Sistema ha Colapsado</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
                    {/* The Crisis */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="bg-surface border-l-4 border-red-500 p-8 rounded-r-xl shadow-lg"
                    >
                        <div className="flex items-center gap-4 mb-6">
                            <ShieldAlert className="text-red-500 w-8 h-8" />
                            <h3 className="text-2xl font-bold text-white">La Crisis</h3>
                        </div>
                        <p className="text-text-muted mb-6 text-lg leading-relaxed">
                            Los partidos tradicionales operan bajo modelos de clientelismo del siglo XX. Son incapaces de resolver crisis sistémicas profundas.
                        </p>
                        <ul className="space-y-3 font-mono text-sm text-zinc-400">
                            <li className="flex items-center gap-2"><span className="text-red-500">✖</span> <strong>Agua:</strong> Colonias sin servicio +12 horas/día</li>
                            <li className="flex items-center gap-2"><span className="text-red-500">✖</span> <strong>Seguridad:</strong> Impunidad total en delitos menores</li>
                            <li className="flex items-center gap-2"><span className="text-red-500">✖</span> <strong>Movilidad:</strong> Infraestructura colapsada</li>
                        </ul>
                    </motion.div>

                    {/* The Solution */}
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="bg-surface border-l-4 border-primary p-8 rounded-r-xl shadow-lg relative overflow-hidden"
                    >
                        <div className="absolute top-0 right-0 p-4 opacity-5">
                            <Zap size={100} />
                        </div>
                        <div className="flex items-center gap-4 mb-6">
                            <Zap className="text-primary w-8 h-8" />
                            <h3 className="text-2xl font-bold text-white">La Solución</h3>
                        </div>
                        <p className="text-text-muted mb-6 text-lg leading-relaxed">
                            Un nuevo modelo de gobernanza basado en <strong>Ingeniería de Sistemas</strong> y evidencia científica.
                        </p>
                        <ul className="space-y-3 font-mono text-sm text-zinc-400">
                            <li className="flex items-center gap-2"><span className="text-primary">✔</span> <strong>Ciencia:</strong> Decisiones basadas en datos, no votos.</li>
                            <li className="flex items-center gap-2"><span className="text-primary">✔</span> <strong>Transparencia:</strong> Rastreo de gasto público con blockchain.</li>
                            <li className="flex items-center gap-2"><span className="text-primary">✔</span> <strong>Accountability:</strong> Métricas de impacto en tiempo real.</li>
                        </ul>
                    </motion.div>
                </div>

                {/* Quote */}
                <div className="max-w-4xl mx-auto text-center">
                    <blockquote className="text-3xl font-display font-light italic text-white leading-relaxed">
                        "Mientras otros ofrecen <span className="text-zinc-500 line-through decoration-red-500">esperanza</span>, nosotros ofrecemos <strong className="text-primary not-italic">certeza matemática</strong>."
                    </blockquote>
                </div>
            </div>
        </section>
    );
};

export default Vision;
